module.exports = __webpack_public_path__ + "img/1.303fb137.jpg";